export const DEFAULT_DASHBOARD_TABS_ID = 'dashboard-bottom-tabs';
